export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  calibrates: state => state.calibrates,
  calibrate: state => state.calibrate,
  calibrateEvents: state => state.calibrateEvents,
  calibrateEvent: state => state.calibrateEvent,
  calibrateEventCurrent: state => state.calibrateEventCurrent,
  highlightSave: state => state.highlightSave,
  isCalibrateChecked: state => state.isCalibrateChecked,
  calibrateServiceRates: state => state.calibrateServiceRates,
  repairlines: state => state.repairlines,
  calibrateCounts: state => state.calibrateCounts,
  isChange: state => state.isChange,
  isCalibrateEventDialog: state => state.isCalibrateEventDialog,
  requestServices: state => state.requestServices
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/getters.js